"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoursesSearcherApi = void 0;
var tslib_1 = require("tslib");
var Search_utils_1 = require("../Search.utils");
var SearchBaseApi_1 = require("../SearchBaseApi");
var CoursesSearcherApi = /** @class */ (function (_super) {
    tslib_1.__extends(CoursesSearcherApi, _super);
    function CoursesSearcherApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hitsDefaultValue = 300;
        return _this;
    }
    CoursesSearcherApi.prototype.buildQuery = function (params) {
        var builder = new Search_utils_1.SearchParamsBuilder();
        builder.Append('q', params.query || '*');
        builder.Append('lang', params.language ? params.language.toLowerCase() : params.language);
        builder.Append('hits', params.hits ? params.hits : this.hitsDefaultValue);
        return decodeURIComponent(builder.toString());
    };
    return CoursesSearcherApi;
}(SearchBaseApi_1.SearchBaseApi));
exports.CoursesSearcherApi = CoursesSearcherApi;
